import { render, staticRenderFns } from "./AccidentDataForm.vue?vue&type=template&id=cd94512e&scoped=true"
import script from "./AccidentDataForm.vue?vue&type=script&lang=js"
export * from "./AccidentDataForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentDataForm.vue?vue&type=style&index=0&id=cd94512e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd94512e",
  null
  
)

export default component.exports